import { Navbar } from './sections/Navbar';
import { HeroSection } from './sections/HeroSection';
import { FeaturesGrid } from './sections/FeaturesGrid';
import { StatsSection } from './sections/StatsSection';
import { HowItWorks } from './sections/HowItWorks';
import { Testimonials } from './sections/Testimonials';
import { PricingSection } from './sections/PricingSection';
import { TrustedBy } from './sections/TrustedBy';
import { CTASection } from './sections/CTASection';
import { ContactForm } from './sections/ContactForm';
import { Mail } from 'lucide-react';
import { cn } from "@/lib/utils";
import { GDPRCompliance } from '../common/GDPRCompliance';

export function LandingPage() {
  return (
    <div className="bg-background min-h-screen flex flex-col">
      <main className="flex-grow">
        <Navbar />
        <HeroSection />
        <TrustedBy />
        <FeaturesGrid />
        <HowItWorks />
        <StatsSection />
        <Testimonials />
        <PricingSection />
        <ContactForm />
        <CTASection />
      </main>

      <footer className="bg-muted border-t border-border mt-auto">
        <div className="container max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center space-x-4">
                <img
                  src="/images/logo.png"
                  alt="TopMatchTalent Logo"
                  className="h-9 w-auto"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground">TopMatchTalent.com</p>
                  <a 
                    href="mailto:talent@topmatchtalent.com" 
                    className={cn(
                      "text-xs text-muted-foreground hover:text-primary transition-colors duration-200", 
                      "inline-flex items-center gap-1.5"
                    )}>
                    <Mail className="h-3.5 w-3.5" />
                    <span>talent@topmatchtalent.com</span>
                  </a>
                </div>
              </div>
              <p className="text-xs text-muted-foreground text-center md:text-right">
                © {new Date().getFullYear()} TopMatchTalent. All rights reserved.
              </p>
            </div>
            
            {/* GDPR Compliance Badges */}
            <div className="border-t border-border pt-6">
              <div className="flex flex-col items-center gap-4">
                <GDPRCompliance variant="footer" className="justify-center" />
                <p className="text-xs text-muted-foreground text-center max-w-2xl">
                  We are committed to protecting your privacy and ensuring GDPR compliance. 
                  Your data is encrypted, stored securely, and never shared without your consent.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}